import React from "react";
var CashWithdraw = function CashWithdraw(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--fill-area-one",
    fill: "#00B095",
    d: "M83.436 75.305a2.123 2.123 0 0 1-2.123 2.148H21.889a2.124 2.124 0 0 1-2.123-2.148c.23-18.49 3.478-26.729 10.587-44.565H72.82c7.147 17.836 10.391 26.079 10.616 44.565"
  }), /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--stroke",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M77.78 43.48h18.397a4.247 4.247 0 0 0 4.246-4.247V22.247a4.26 4.26 0 0 0-1.243-3.003A4.25 4.25 0 0 0 96.177 18H6.997a4.245 4.245 0 0 0-4.247 4.247v16.986a4.247 4.247 0 0 0 4.247 4.247h18.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--fill-area-two",
    fill: "#fff",
    fillOpacity: ".6",
    d: "M75.75 38.122c-5.29 3.618-11.363 7.06-17.595 10.594C44.228 56.611 29.5 64.961 20.907 76.731l-.157.39a2.1 2.1 0 0 1-.83-.996 2.1 2.1 0 0 1-.154-.82c.23-18.49 3.478-26.729 10.587-44.565H72.82a810 810 0 0 1 2.93 7.382"
  }), /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--stroke",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M83.436 75.305a2.123 2.123 0 0 1-2.123 2.148H21.889a2.124 2.124 0 0 1-2.123-2.148c.23-18.49 3.478-26.729 10.587-44.565H72.82c7.147 17.836 10.391 26.079 10.616 44.565m-59.453 10.64h55.206M17.613 30.74h72.193m-38.22 10.617V37.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--stroke",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M57.957 41.355H49.34a5.699 5.699 0 0 0-2.123 10.987l8.765 3.507a5.7 5.7 0 0 1-2.123 10.986h-8.642m6.369 4.247v-4.247"
  }));
};
CashWithdraw.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 104 104",
  fill: "none"
};
import createIconPlusComponent from '../createIconPlusComponent';
export const CashWithdrawIconPlus = createIconPlusComponent(CashWithdraw, 'CashWithdraw');